(function() {
  'use strict';

  angular
    .module('quiz.labelingItemsInPicture')
    .directive('lipCaption', lipCaption);

  lipCaption.$inject = [];

  function lipCaption() {
    return function(scope, element, attr) {
      var rightMargin = 31;
      var captionLeft = 820;
      var topMargin = 50;
      var labelSpacing = 50;

      element.draggable({
        containment: "#lipContainer",
        zIndex: 100,
        scroll: true,
        revert: "invalid",
        start: startDrag,
        stop: stopDrag
      });

      scope.$watch(attr.dragDisabled, function(value) {
        element.draggable("option", "disabled", value);
      }, true);

      var caption;
      scope.$watch(attr.lipCaption, function(value) {
        caption = value;
      });

      var viewModel;
      scope.$watch(attr.lipCaptionViewModel, function(value) {
        viewModel = value;
      });

      //We need to respond when the regionIdx changes, but since it is already in our model, we throw the value away.
      scope.$watch(attr.lipCaptionRegionIdx, function(regionIdx) {
        if (!caption) return;
        redraw();
      });

      scope.$on('redraw', redraw);

      function redraw() {
        var region = viewModel.regions[caption.regionIdx];
        if (region) {
          var positionStyle = getPositionStyle(region);
          element.stop(true).animate(positionStyle, 250);
          return;
        }

        element.stop(true).animate({
          top: topMargin + caption.index * labelSpacing,
          left: captionLeft
        }, 750);
      }

      function getPositionStyle(region) {
        if (!region || !region.captionPosition) return {};

        var style = {};

        var x = region.captionPosition.x;
        var y = region.captionPosition.y;

        if (region.captionPosition.left)
          x -= rightMargin;

        style.left = x;
        style.top = y;
        return style;
      }

      function startDrag() {
        scope.$eval(attr.lipCaptionDragBegin);
        scope.$apply();
      }

      function stopDrag() {
        scope.$eval(attr.lipCaptionDragStop);
        scope.$apply();
      }
    };
  }
})();
